import { useOutsideClick } from '../../../utils/helper.js';
import React from 'react';
import { useRef, useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import // APPROVAL_STATUS_DROPDOWN,
// CONTENT_APPROVAL_STATUS,
// CONTENT_TYPE,
// PER_PAGE
'../../../utils/constants.js';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import Loader from '../../../component/common/Loader.js';
import Topbar2 from '../../PulseSurvey/Topbar.js';
import AddDetails from './AddDetails.js';
import BadgeTaskForm from '../../B2B/B2BAdmin/Badges/Components/BadgeTaskForm.js';
import TaskRewardForm from '../components/Reward.js';
import WinnerResult from '../components/WinnerResult.js';
import SendEmail from '../components/SendEmail.js';
import ChallengePreview from './ChallengePreview.js';
import toast from 'react-hot-toast';
import axios from 'axios';

import { Api } from '../../../api';
// import { errorToast, getFileType, successToast } from '../../../../utils/helper';
import { getFileType } from '../../../utils/helper.js';

function NewChallenges() {
  const location = useLocation();
  const state = location.state;
  console.log(state?._id, 'state_idddddd');
  // const { userType, companyId } = JSON.parse(localStorage.getItem('userData'));
  // const selectedTheme = JSON.parse(localStorage.getItem('selectedTheme'));
  const calendarRef = useRef(null);
  const [isOpen2, setIsOpen2] = useState(false);
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);

  const [showPage, setShowPage] = useState(''); //  createcompany or tasks

  // const pages = [{ name: 'Marketplace', href: '/create-new-company-offer', current: true }];

  useOutsideClick(calendarRef, () => {
    setIsOpen2(false);
  });

  // Update showPage state based on URL query parameter
  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const pageParam = queryParams.get('page');

    setShowPage(pageParam ? pageParam.toLowerCase() : 'details');
  }, [location.search]);

  const handlePageChange = (page) => {
    setShowPage(page.toLowerCase());
    navigate(`/challenges/create-new-challenges?page=${page}`, {
      state: {
        _id: state?._id
      }
    });
  };
  const propsData = location.state;
  // const state = location.state;
  // console.log(propsData,"propsDatapropsDatapropsData");
  // console.log("propsData", propsData)
  const [data, setData] = useState({});

  console.log(data, 'dataaaaaaaa');

  const handleFinalSubmit = async () => {
    setLoader(true);
    const body = {
      challenge_id: state?._id
    };

    // if (data.formData.image && getFileType(data.formData.image)) {
    //     body.image = getFileType(data.formData.image);
    // }
    // if (data.formData.title) {
    //     body.title = data.formData.title;
    // }

    // if (data.formData.wellpoints) {
    //     body.wellpoints = data.formData.wellpoints;
    // }

    // if (data.formData._id) {
    //     body.badge_id = data.formData._id;
    // } else {
    //     body.status = 'draft';
    // }

    // Flatten and add tasks if available
    const flatTasks =
      data?.tasks?.flatMap((group) =>
        group.sub_tasks.map((task) => ({
          ...task,
          feature: task?.backend_name
        }))
      ) || [];

    if (flatTasks.length > 0) {
      body.tasks = flatTasks;
    }
    // console.log(body,"bodybodybodybody");
    // API call
    //     setLoader(false)
    // return
    const response = await Api.addChallengesTask(body);
    console.log('response-001', response);

    if (response?.status === 200) {
      toast.success(response?.data?.message);
      navigate('/challenges/create-new-challenges?page=reward',{state:{
            _id:response?.data?.challenge?._id
          }});
      // if (data.formData.image && getFileType(data.formData.image)) {
      //     axios
      //         .put(response?.data?.badge?.uploadURL, data.formData.image, {
      //             headers: {
      //                 'content-type': `${getFileType(data.formData.image)?.split('/')[0]}/${data.formData.image?.name?.split('.')[1]
      //                     }`
      //             }
      //         })

      //     !data.formData._id && setData(prev => ({
      //         ...prev,
      //         formData: {
      //             ...prev.formData,
      //             _id: response?.data?.badge?._id
      //         }
      //     }));
      // }
      setLoader(false);
      // navigate('/active-badges/preview', {
      //     state: {
      //         ...data,
      //         formData: {
      //             ...data.formData,
      //             _id: response?.data?.badge?._id
      //         }
      //     }
      // });
    } else {
      setLoader(false);
      toast.error(response?.data?.message);
    }
  };

  return (
    <>
      <div className="relative lg:ps-5 lg:mb-[45px]">
        <Helmet>
          <meta charSet="utf-8" />
          <title>Marketplace | Shoorah Admin</title>
        </Helmet>
        {loader ? <Loader /> : null}
        <Topbar2
          title={
            showPage === 'details'
              ? 'Challenges/New Challenge'
              : showPage === 'tasks'
              ? 'Challenges/New Challenge '
              : showPage === 'reward'
              ? 'Challenges/New Challenge'
              : showPage === 'results'
              ? 'Challenges/New Challenge '
              : showPage === 'preview'
              ? 'Challenges/New Challenge'
              : ''
          }
          infoBtn={false}
        />
      </div>

      <div className="relative lg:pl-5 lg:mb-[45px]">
        {showPage !== 'preview' && (
          <div className="flex flex-wrap sm:flex-nowrap justify-between items-center w-full gap-4 lg:gap-12">
            <div className="flex gap-4 sm:gap-8">
              <div
                className={`cursor-pointer text-[20px] font-medium leading-9 ${
                  showPage === 'details'
                    ? 'text-shoorah-lightBlack dark:text-shoorah-darkBg'
                    : 'text-shoorah-gray9'
                }`}
                onClick={() => handlePageChange('details')}
              >
                Details
              </div>
              <div
                className={`cursor-pointer text-[20px] font-medium leading-9 ${
                  showPage === 'tasks'
                    ? 'text-shoorah-lightBlack dark:text-shoorah-darkBg'
                    : 'text-shoorah-gray9'
                }`}
                onClick={() => handlePageChange('tasks')}
              >
                Tasks
              </div>
              <div
                className={`cursor-pointer text-[20px] font-medium leading-9 ${
                  showPage === 'reward'
                    ? 'text-shoorah-lightBlack dark:text-shoorah-darkBg'
                    : 'text-shoorah-gray9'
                }`}
                onClick={() => handlePageChange('reward')}
              >
                Reward
              </div>
              {/* <div
              className={`cursor-pointer text-[20px] font-medium leading-9 ${showPage === 'results'
                ? 'text-shoorah-lightBlack dark:text-shoorah-darkBg'
                : 'text-shoorah-gray9'
                }`}
            //   onClick={() => handlePageChange('results')}
            >
              Share
            </div> */}
              <div
                className={`cursor-pointer text-[20px] font-medium leading-9 ${
                  showPage === 'results'
                    ? 'text-shoorah-lightBlack dark:text-shoorah-darkBg'
                    : 'text-shoorah-gray9'
                }`}
                onClick={() => handlePageChange('results')}
              >
                Results
              </div>
              <div
                className={`cursor-pointer text-[20px] font-medium leading-9 ${
                  showPage === 'email'
                    ? 'text-shoorah-lightBlack dark:text-shoorah-darkBg'
                    : 'text-shoorah-gray9'
                }`}
                onClick={() => handlePageChange('email')}
              >
                Email
              </div>
            </div>

            <div className="flex justify-center items-center w-full sm:w-[170px] h-[40px] text-[14px] border border-[#0B1D2E] rounded-[100px] ">
              <div className="relative inline-block text-left">
                <button
                  type="button"
                  le
                  dropdown
                  on
                  button
                  click
                  className="inline-flex justify-between items-center w-full px-3 py-2 text-sm font-medium text-gray-700  focus:outline-none"
                >
                  <div
                    className={` cursor-pointer text-[14px] font-medium leading-9  text-shoorah-lightBlack dark:text-shoorah-darkBg`}
                    onClick={() => handlePageChange('preview')}
                  >
                    Preview Challenge
                  </div>
                </button>
              </div>
            </div>
          </div>
        )}

        {showPage === 'details' && (
          <div className="mt-4">
            <AddDetails data={data} setData={setData} />
          </div>
        )}

        {
          showPage === 'tasks' && (
            <BadgeTaskForm
              handleFinalSubmit={handleFinalSubmit}
              challange={true}
              data={data}
              setData={setData}
            />
          )
          // <BadgeTaskForm handleFinalSubmit={handleFinalSubmit} handleChangeType={handleChangeType} challange={true} data={data} setData={setData} />
        }
        {showPage === 'reward' && <TaskRewardForm />}
        {showPage === 'results' && <WinnerResult data={data} setData={setData} />}
        {showPage === 'email' && <SendEmail data={data} setData={setData} />}
        {showPage === 'preview' && (
          <ChallengePreview handlePageChange={handlePageChange} />
        )}
      </div>
    </>
  );
}

export default NewChallenges;
